<template>
  <div id="register">
      <div class="container">        
          <div class="row pt-4 pb-4">
            
              <div class="login-window d-flex">
                  <div class="slider reasonbg p-5">

                    <h2 class="text-center pb-3"><span>{{$t('5 reasons')}}</span> {{$t('to buy from us')}}</h2>
                    <ul class="row">
                       <li class="col-md-6 text-center">
                          <i class="reason-icon reason-1"></i>
                          <p>{{ $t('We are 100 % Finnish company, we employ people in Finland, we pay taxes in Finland.') }}</p>
                      </li>
                      <li class="col-md-6 text-center">
                          <i class="reason-icon reason-4"></i>
                          <p>{{ $t('We have large amount of service partners which cover all Finland, over 1000 free fitting times daily.') }}</p>
                      </li>
                      <li class="col-md-6 text-center">
                          <i class="reason-icon reason-2"></i>
                          <p>{{ $t('Low prices, own big stock and wide range of tyres, part payment, many different payment methods.') }}</p>
                      </li>
                      <li class="col-md-6 text-center">
                          <i class="reason-icon reason-3"></i>
                          <p>{{ $t('Fast delivery 24h, good service, Chat open.') }}</p>
                      </li>
                      <li class="col-md-12 text-center">
                          <i class="reason-icon reason-5"></i>
                          <p>{{ $t('Purchasing tyres from Finland you help reduce CO2 emission, we sale Ecological Tyres also.') }}</p>
                      </li>
                    </ul>
                      
                  </div>
                  <div class="login-form register-form">
                      
                      <div class="d-flex flex-column mb-2">
                        <h1>{{ $t('Register') }}</h1>
                        <p>{{$t('Please enter your details to register as a customer')}}</p>
                      </div>

                      <form class="w-100" @submit.stop.prevent="handleSubmit" autocomplete="off">

                          <div v-if="loading" class="loading"></div>

                          <div class="row">

                              <div v-if="isShow" class="col-12">
                                <bootstrap-alert 
                                    :variant="response.variant" 
                                    :msg="response.message" 
                                    :errorMsg="response.errmsg" 
                                />
                            </div>

                              <!-- <div class="col-12 cs-salutation">
                                <label for="salutation">
                                    {{ $t('Salutation') }}
                                    <span class="required">*</span>
                                  </label>

                                  <b-form-select 
                                    v-model="salutation" 
                                    :options="options" 
                                    id="salutation" 
                                    name="salutation" 
                                    class="form-control input-field selectcustom" >
                                  </b-form-select>

                              </div> -->
                              <div class="col-12 cs-name">
                                  <div class="form-group">
                                      <label for="firstname">
                                        {{ $t('Firstname') }}
                                        <span class="required">*</span>
                                      </label>
                                      <input 
                                        type="text" 
                                        class="form-control input-field" 
                                        id="firstname" 
                                        v-model="first_name" 
                                        name="firstname" 
                                        :placeholder="$t('Firstname')"
                                        required="required" />
                                </div>
                              </div>
                              <div class="col-12 cs-name">
                                  <div class="form-group">
                                      <label for="lastname">
                                        {{ $t('Lastname') }}
                                        <span class="required">*</span>
                                      </label>

                                      <input 
                                        type="text" 
                                        class="form-control input-field" 
                                        id="lastname" 
                                        v-model="last_name" 
                                        name="lastname" 
                                        :placeholder="$t('Lastname')"
                                        required="required" />
                                </div>
                              </div>
                          </div>

                          <div class="row">
                             
                              <div class="col-12">
                                  
                                <b-form-group :label="$t('Become customer as ?')">
                                  <div class="row become-customer-as">
                                    <div class="col-lg-4 col-md-4 col-xs-12"><b-form-radio v-model="is_company_user" name="is_company_user " value="0">{{ $t('Private person') }}</b-form-radio></div>
                                    <div class="col-lg-4 col-md-4 col-xs-12"><b-form-radio v-model="is_company_user" name="is_company_user " value="1">{{ $t('Company user') }}</b-form-radio></div>
                                  </div>
                                </b-form-group>
                                
                              </div>
                              
                              <div class="col-lg-6 col-md-6 col-xs-12" v-if="is_company_user == 1">

                                  <div class="form-group">
                                    <label for="company_name">
                                      {{ $t('Company Name') }}
                                      <span class="required">*</span>
                                    </label>
                                    <input 
                                      type="text" 
                                      class="form-control input-field" 
                                      id="company_name" 
                                      v-model="company_name" 
                                      name="company_name" 
                                      :placeholder="$t('Company Name')"
                                      required="required" />
                                  </div>
                              </div>

                              <div class="col-lg-6 col-md-6 col-xs-12" v-if="is_company_user == 1">

                                  <div class="form-group">
                                    <label for="company_vat_number">
                                      {{ $t('Company VAT Number') }}
                                    </label>
                                    <input 
                                      type="text" 
                                      class="form-control input-field" 
                                      id="company_vat_number" 
                                      v-model="company_vat_number" 
                                      name="company_vat_number" 
                                      :placeholder="$t('Company VAT Number')" />
                                  </div>
                              </div>

                              <div class="col-12">
                                  <div class="form-group">
                                      
                                      <label for="contact_number">
                                        {{ $t('Contact number') }}
                                        <span class="required">*</span>
                                      </label>
                                    <div class="d-flex">
                                          <!-- <vue-country-code
                                              @onSelect="onSelect"
                                              :preferredCountries="['fi', 'vn', 'us', 'gb']"
                                              :disabledFetchingCountry="false"
                                              v-bind="bindProps"
                                              v-model="country_code"
                                              class="country-select"
                                              >
                                          </vue-country-code> -->
                                      <input 
                                        type="text" 
                                        class="form-control input-field" 
                                        id="contact_number" 
                                        v-model="contact_number" 
                                        @keypress="isPhoneNo()"
                                        name="contact_number" 
                                        :placeholder="$t('Contact number')"
                                        required="required" />

                                    </div>
                                       
                                </div>
                              </div>
                          </div>
                          <div class="form-group">
                                      <label for="email">
                                        {{ $t('Email') }}
                                        <span class="required">*</span>
                                      </label>
                                      <input 
                                        type="email" 
                                        class="form-control input-field" 
                                        id="email" 
                                        v-model="email" 
                                        name="email"
                                        :placeholder="$t('Email')"
                                        required="required" />
                                      <span v-if="emailError" class="error">{{ $t('Email is required') }}</span>
                                      <span v-if="emailvalid" class="error">{{ $t('Please enter valid email') }}</span>
                          </div>
                          
                          <div class="row">
                              <div class="col-12">
                                <div class="form-group">
                                      <label for="password">
                                        {{ $t('Password') }}
                                        <span class="required">*</span>
                                      </label>

                                      <div>
                                        <div class="row my-2">
                                          <div class="col-6">
                                            <i class="fa fa-check text-success mr-2" v-if="contains_eight_characters"></i>
                                            <i class="fa fa-times text-danger mr-2" v-else></i>
                                            <label>{{ $t('Min. 8 characters') }}</label>
                                          </div>
                                          <div class="col-6">
                                            <i class="fa fa-check text-success mr-2" v-if="contains_number"></i>
                                            <i class="fa fa-times text-danger mr-2" v-else></i>
                                            <label>{{ $t('At least 1 number') }}</label>
                                          </div>
                                        </div>
                                        <div class="row my-2">
                                          <div class="col-6">
                                            <i class="fa fa-check text-success mr-2" v-if="contains_uppercase"></i>
                                            <i class="fa fa-times text-danger mr-2" v-else></i>
                                            <label>{{ $t('At least 1 uppercase letter') }}</label>
                                          </div>
                                          <div class="col-6">
                                            <i class="fa fa-check text-success mr-2" v-if="contains_special_character"></i>
                                            <i class="fa fa-times text-danger mr-2" v-else></i>
                                            <label>{{ $t('At least 1 special character') }}</label>
                                          </div>
                                        </div>
                                      </div>
                                      <password
                                        v-model="password"
                                        :toggle="true"
                                        @score="showScore"
                                        @feedback="showFeedback"
                                        @input="checkPassword"
                                        :required="true"
                                        :badge="false"
                                        :showStrengthMeter="false"
                                      />

                                </div>
                              </div>

                              <div class="col-12">
                                <div class="form-group">
                                      <label for="confirmpassword">
                                        {{ $t('Confirm Password') }}
                                        <span class="required">*</span>
                                      </label>
                                      <input 
                                        type="password" 
                                        class="form-control input-field" 
                                        id="confirmpassword" 
                                        v-model="confirmpassword" 
                                        name="confirmpassword" 
                                        :placeholder="$t('Confirm Password')"
                                        required="required" />
                                      <span v-if="confirmpassError" class="error">{{ $t('Confirm Password is required') }}</span>
                                      <span v-if="samepassError" class="error">{{ $t('Password is not match.') }}</span>
                                </div>
                              </div>
                          </div>

                          <captcha :form="form" ref="captchObj"></captcha>

                            <p class="font-12">{{ $t('By clicking on Register,')}} <br/>
                              {{ $t('you agree to our') }} <router-link :to="{ name: 'cmspage', params: {pagepath: 'terms-and-condition' } }" target="_blank">{{ $t('Terms and conditions') }}</router-link> & <router-link :to="{ name: 'cmspage', params: {pagepath: 'privacy-policy' } }" target="_blank">{{ $t('Privacy Policy') }}</router-link></p class="font-12">
                            <b-button  type="submit" 
                              :disabled="!valid_password" 
                              class="btn btn-primary d-block w-100 login-button bg-black">{{ $t('REGISTER') }} </b-button>
                      </form>   
                      <p class="d-block p-3 w-100 mb-0 text-center">{{ $t('Already have an account?') }} <router-link class="color-black font-weight-bold" :to="{ name: 'login' }">{{ $t('Login!') }}</router-link></p>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Vue from "vue";
import VueCountryCode from "vue-country-code";
import Password from 'vue-password-strength-meter';
import Captcha from '../components/Captcha'

Vue.use(VueCountryCode);
//import { ValidationProvider } from "vee-validate";

export default {
  name: "register",
  metaInfo: {
        title: 'Registration',
        meta: [
            { charset: 'utf-8' },
            { name: 'title', content:  'Registration'},
            {name: 'description', content: 'This is Registration page'},
            { name: 'keywords', content:  'Registration, renkaatalle, Renkaatalle.fi'},
            { name: 'robots', content: 'index,follow'}
        ],
        link: [
            {rel: 'canonical', href: process.env.VUE_APP_BASE_URL + 'register'}
        ]
    },
  data() {
    return {
      form:{
      },
      salutation: "mr",
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      confirmpassword: "",
      country_code: '358',
      company_name: "",
      company_vat_number: "",
      is_company_user: '0',
      contact_number: '',
      emailError: false,
      emailvalid: false,
      passError: false,
      confirmpassError: false,
      samepassError: false,
      valid_password: false,
      password_length: 0,
      contains_eight_characters: false,
      contains_number: false,
      contains_uppercase: false,
      contains_special_character: false,
      bindProps: {
          defaultCountry: "FI"
      },
      options: [
        { value: 'mr', text: this.$t('Mr')  },
        { value: 'miss', text: this.$t('Miss') },
        { value: 'mrs', text: this.$t('Mrs') }
      ],
      
    };
  },
  components: {
    //ValidationProvider
    Password,
    Captcha
  },
  computed: {
    ...mapGetters('auth', ['response', 'isShow', 'loading']),
    ...mapGetters('app', ['currentLang'])
  },
  created() {
    if(this.isShow) {
      var self = this;
      setTimeout(function(){ 

        self.setIsShow(false)
        
      }, 3000);
    }
  },
  methods: {
    ...mapActions("register", ["storeData", "setIsShow"]),
    ...mapActions("auth", ["login", "registerCustomer", "setIsShow"]),
    
    handleSubmit() {
      var setflag = 1;
      this.emailError = false;
      this.passError = false;
      this.confirmpassError = false;
      this.samepassError = false;
      this.emailvalid = false;

      if (this.email == "") {
        this.emailError = true;
        setflag = 0;
      } else {
        var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        var valid = regex.test(this.email);
        if (!valid) {
          this.emailvalid = true;
          setflag = 0;
        }
      }

      if (this.password == "") {
        this.passError = true;
        setflag = 0;
      }

      if (this.confirmpassword == "") {
        this.confirmpassError = true;
        setflag = 0;
      }

      if (this.password != this.confirmpassword) {
        this.samepassError = true;
        setflag = 0;
      }

      if (setflag) {
        let formdata = {
          salutation: this.salutation,
          first_name: this.first_name,
          last_name: this.last_name,
          contact_number: this.contact_number,
          country_code: this.country_code,
          email: this.email,
          password: this.password,
          is_company_user: this.is_company_user,
          company_name: this.company_name,
          company_vat_number: this.company_vat_number,
          captcha: this.form.captcha,
          captcha_id:this.form.captcha_id
        };
        
        var resResponse  = this.registerCustomer(formdata)
            .then(() => {
                this.showError = false
                this.setIsShow(true)
                this.klaviyoIdentifyUser(this.email)
                this.$router.push({ name: 'profile', replace: true }).catch(err => {});
            })
            .catch((error) => {
                this.$refs.captchObj.refreshCaptcha()
                
                if(error.response.data)
                {
                    this.errorMessage = error.response.data
                    this.showError = true
                } else {
                    this.showError = false
                    this.$router.push({ 
                        name: '/register',
                        replace: true
                    }).catch(err => {});
                }
            });
      }
    },
    onSelect({name, iso2, dialCode}) {
        this.country_code = dialCode;
    },
    checkPassword() {
      this.password_length = this.password.length;
      const format = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;

      if (this.password_length > 8) {
          this.contains_eight_characters = true;
      } else {
          this.contains_eight_characters = false;
              }

      this.contains_number = /\d/.test(this.password);
      this.contains_uppercase = /[A-Z]/.test(this.password);
              this.contains_special_character = format.test(this.password);

      if (this.contains_eight_characters === true &&
                      this.contains_special_character === true &&
                      this.contains_uppercase === true &&
                      this.contains_number === true) {
                          this.valid_password = true;
      } else {
          this.valid_password = false;
      }
    },
    showFeedback ({suggestions, warning}) {
      
    },
    showScore (score) {
      return 2;
      console.log(score)
    }
  }
};
</script>